export const sportsDataset = [
  { value: "Rugby Union", label: "Rugby Union" },
  { value: "Rugby League", label: "Rugby League" },
  { value: "Rugby Sevens", label: "Rugby Sevens" },
  { value: "Australian Rules Football", label: "Australian Rules Football" },
  { value: "Soccer", label: "Soccer" },
  { value: "Basketball", label: "Basketball" },
  { value: "Netball", label: "Netball" },
  { value: "Cricket", label: "Cricket" },
  { value: "Tennis", label: "Tennis" },
  { value: "Volleyball", label: "Volleyball" },
  { value: "Baseball", label: "Baseball" },
  { value: "Softball", label: "Softball" },
  { value: "Hockey", label: "Hockey" },
  { value: "Ice Hockey", label: "Ice Hockey" },
  { value: "American Football", label: "American Football" },
  { value: "Golf", label: "Golf" },
  { value: "Athletics", label: "Athletics" },
  { value: "Swimming", label: "Swimming" },
  { value: "Cycling", label: "Cycling" },
  { value: "Boxing", label: "Boxing" },
  { value: "MMA", label: "MMA" },
  { value: "Wrestling", label: "Wrestling" },
  { value: "Judo", label: "Judo" },
  { value: "Taekwondo", label: "Taekwondo" },
  { value: "Karate", label: "Karate" },
  { value: "Gymnastics", label: "Gymnastics" },
  { value: "Badminton", label: "Badminton" },
  { value: "Table Tennis", label: "Table Tennis" },
  { value: "Squash", label: "Squash" },
  { value: "Rowing", label: "Rowing" },
  { value: "Canoeing", label: "Canoeing" },
  { value: "Kayaking", label: "Kayaking" },
  { value: "Surfing", label: "Surfing" },
  { value: "Sailing", label: "Sailing" },
  { value: "Water Polo", label: "Water Polo" },
  { value: "Triathlon", label: "Triathlon" },
  { value: "Weightlifting", label: "Weightlifting" },
  { value: "Powerlifting", label: "Powerlifting" },
  { value: "CrossFit", label: "CrossFit" },
  { value: "Bodybuilding", label: "Bodybuilding" },
  { value: "Equestrian", label: "Equestrian" },
  { value: "Archery", label: "Archery" },
  { value: "Fencing", label: "Fencing" },
  { value: "Skateboarding", label: "Skateboarding" },
  { value: "Snowboarding", label: "Snowboarding" },
  { value: "Skiing", label: "Skiing" },
  { value: "Rock Climbing", label: "Rock Climbing" },
  { value: "Bouldering", label: "Bouldering" },
  { value: "Handball", label: "Handball" },
  { value: "Lacrosse", label: "Lacrosse" },
  { value: "Ultimate Frisbee", label: "Ultimate Frisbee" },
  { value: "Touch Football", label: "Touch Football" },
  { value: "OzTag", label: "OzTag" },
  { value: "DanceSport", label: "DanceSport" },
  { value: "Motorsport", label: "Motorsport" },
  { value: "Esports", label: "Esports" },
];

export default sportsDataset;
